<template>
    <el-container>
        <!-- 主体内容 -->
        <el-header style="display: flex; align-items: center; justify-content: space-between">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>AI舆情分析</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button-group>
                <el-button type="info" icon="el-icon-refresh" @click.native="refresh">重新开始</el-button>
            </el-button-group>
        </el-header>
        <el-main>
            <div style="display: flex;gap:10px;justify-content: space-between;flex-wrap: nowrap">
                <el-button @click.native="preHandleClick" :disabled="active == 0 ? true : false"><i
                        class="el-icon-arrow-left" /></el-button>
                <div style="flex-grow:5">
                    <el-steps :active="active" finish-status="success" align-center>
                        <el-step title="查询设置" description="设置舆情分析查询条件"></el-step>
                        <el-step title="需求设置" description="设置舆情分析需求"></el-step>
                        <el-step title="AI分析结果" description="AI分析结果"></el-step>
                    </el-steps>
                </div>
                <el-button @click.native="nextHandleClick" :disabled="active == 2 ? true : false"><i
                        class="el-icon-arrow-right" /></el-button>
            </div>
            <div>
                <el-divider></el-divider>
                <el-tabs type="border-card" v-model="query.selectType">
                    <el-tab-pane label="设置查询条件" name="0">
                        <el-form :model="query" ref="outputRef" status-icon label-width="80px">
                            <el-form-item label="时间区间" prop="dateRangeValue">
                                <el-date-picker v-model="query.dateRangeValue" type="daterange" start-placeholder="开始日期"
                                    end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"
                                    value-format="yyyy-MM-dd HH:mm:ss" />
                            </el-form-item>
                            <el-form-item label="转办单位" prop="unitIds">
                                <el-select v-model="query.unitIds" placeholder="请选择" filterable multiple collapse-tags>
                                    <el-option v-for="unit in units.filter(
                                        (item) => item.name != '所有单位'
                                    )" :key="unit.id" :label="unit.name" :value="unit.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="工单类型" prop="pstType">
                                <el-select v-model="query.pstTypes" placeholder="请选择" multiple collapse-tags>
                                    <el-option v-for="pstType in pstApi.pstTypes.filter(
                                        (item) => item.value != -1
                                    )" :key="pstType.value" :label="pstType.title" :value="pstType.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="工单状态" prop="categorys">
                                <el-select v-model="query.categorys" placeholder="请选择" filterable multiple
                                    collapse-tags>
                                    <el-option v-for="order in pstApi.pstorders" :key="order.value" :label="order.title"
                                        :value="order.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="领域选项" prop="domains">
                                <el-select v-model="query.domains" placeholder="请选择" filterable multiple collapse-tags>
                                    <el-option v-for="domain in domains" :key="domain" :label="domain" :value="domain">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="需求设置" name="1">
                        <el-form :model="demand" status-icon label-width="80px">
                            <el-form-item label="分析需求" prop="title">
                                <el-autocomplete popper-class="my-autocomplete" v-model="demand.title"
                                    :fetch-suggestions="querySearch" placeholder="请输入需求文字内容">
                                    <i class="el-icon-edit el-input__icon" slot="suffix" />
                                    <template slot-scope="{ item }">
                                        <div class="name">{{ item.label }}</div>
                                        <span class="addr">{{ item.value }}</span>
                                    </template>
                                </el-autocomplete>
                            </el-form-item>
                            <el-form-item label="分析选项" prop="isPstContent">
                                <el-checkbox v-model="demand.isPstContent">舆情原文参与分析</el-checkbox>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="生成结果" name="3">
                        <el-form status-icon label-width="80px">
                            <!-- <div class="md_content">
                                <vue-markdown :source="demand.textarea" />
                            </div> -->
                            <div class="page-api" id="myElement">
                                <vue-markdown id="content" class="api-content" :source="markdownContent"></vue-markdown>
                                <div class="api-tree" id="tree">
                                    <el-tree :data="tree" :default-expand-all="true"
                                        @node-click="handleNodeClick"></el-tree>
                                </div>
                            </div>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-main>
    </el-container>
</template>

<script>
import VueMarkdown from 'vue-markdown'
import markdownItAnchor from 'markdown-it-anchor';
import markdownItToc from 'markdown-it-table-of-contents';
import markdownItEmoji from 'markdown-it-emoji';
import markdownItKatex from 'markdown-it-katex';
export default {
    components: { VueMarkdown },
    created() {
        this.pstApi.setWindowTitle("AI舆情分析");
        this.getUnits();
        this.getWebsiteParameter();
    },
    data() {
        return {
            active: 0,
            units: [], //单位数据
            domains: [],
            query: {
                selectType: "0",
                dateRangeValue: null,
                unitIds: [],
                pstTypes: [],
                categories: [],
                domains: [],
                //考核表参数
                dateRangeKaoheValue: null,
            },
            demand: {
                title: "",
                isPstContent: false,
                selects: [
                    {
                        label: '生成舆情日报',
                        value: '根据以上文件生成舆情日报'
                    },
                    {
                        label: '生成舆情报告',
                        value: '根据以上文件生成舆情报告'
                    },
                ],
            },
            markdown: '',
            markdownContent: '',
            tree: [],
            plugins: [markdownItAnchor, [markdownItToc, { includeLevel: [2, 3] }], markdownItEmoji, markdownItKatex]
        };
    },
    methods: {
        preHandleClick() {
            if (this.active > 0) {
                this.active--
                if (this.active == 2) {
                    this.active--
                }
            }
            this.query.selectType = this.active + ""
        },
        nextHandleClick() {
            if (this.active < 3) {
                const dateValue = this.query.dateRangeValue
                if (this.active == 0 && (dateValue == null || dateValue.length < 2)) {
                    this.$toast("请选择时间区间");
                    return;
                }
                if (this.active == 1 && this.demand.title == "") {
                    this.$toast("用户需求不能为空");
                    return;
                }
                this.active++
                if (this.active == 2) {
                    this.active++
                    this.aiSubmit()
                }
            }
            this.query.selectType = this.active + ""
        },
        refresh() {
            this.active = 0
            this.query.selectType = this.active + ""
            this.query.dateRangeValue = null
            this.demand.title = ""
            this.markdownContent = ""
            this.tree = []
        },
        getUnits() {
            this.units = [
                {
                    id: "00000000-0000-0000-0000-000000000000",
                    name: "所有单位",
                },
            ];
            this.userApi.getUnitAll().then((res) => {
                var data = res.data;
                this.data.units = this.data.units.concat(data);
            });
        },
        getWebsiteParameter() {
            this.pstApi
                .getWebsiteParameters()
                .then((resp) => {
                    //读取成功
                    var data = resp.data;
                    this.domains = data.domains;
                })
                .catch((error) => {
                    var message = error.response.data.Message;
                    if (message == null) {
                        message = "服务器访问失败";
                    }
                    this.$toast(message);
                });
        },
        querySearch(queryString, cb) {
            var restaurants = this.demand.selects;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        //AI提交
        aiSubmit() {
            const loading = this.$loading({
                lock: true,
                text: '正在进行舆情分析，请等待...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const dateRangeValues = this.query.dateRangeValue;
            const unitIds = this.query.unitIds;
            const pstTypes = this.query.pstTypes;
            const categories = this.query.categories;
            const domains = this.query.domains;
            const instruction = this.demand.title;
            const isPstContent = this.demand.isPstContent;
            this.pstApi
                .callDeepSeek_File(dateRangeValues, unitIds, pstTypes, categories, domains, instruction, isPstContent)
                .then((res) => {
                    loading.close();
                    this.markdownContent = res.data
                    this.$nextTick(() => {
                        this.catalogTree();
                    });
                })
                .catch((error) => {
                    loading.close();
                    this.$toast("AI分析失败")
                });
        },
        catalogTree() {
            const content = document.getElementById('content').children;
            var arr = [];
            let currentHightestLevel;
            let parentId;
            let index = 0;
            let nodeArr = [];
            let tree = [];
            for (let i = 0; i < content.length; i++) {
                let header = content[i].localName;
                //如果是标题进行下一步
                if (/\b[h][0-9]\b/.test(header)) {
                    let ele = content[i]; // 直接使用DOM元素
                    let name = ele.textContent; // 获取元素的文本内容
                    ele.setAttribute('id', i); // 设置元素的ID

                    let id = i;
                    if (index === 0 || header <= currentHightestLevel) {
                        currentHightestLevel = header;
                        parentId = id;
                    }
                    arr.push({
                        id: id,
                        label: name,
                        parentId: parentId == id ? '0' : parentId
                    });
                    index++;
                }
            }
            arr.forEach((item) => {
                if (item.parentId === '0') {
                    tree.push(this.convertArrayToTree(arr, item));
                }
            });
            this.tree = tree;
        },
        convertArrayToTree(arr, node) {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].parentId === node.id) {
                    const res = this.convertArrayToTree(arr, arr[i]);
                    if (node.children) {
                        node.children.push(res);
                    } else {
                        node.children = [res];
                    }
                }
            }
            return node;
        },
        handleNodeClick(data) {
            let anchorElement = document.getElementById(data.id);

            let scrollPosition = anchorElement.offsetTop - 20;

            let myElement = document.getElementById('myElement');
            myElement.scrollTo({
                left: 0,
                top: scrollPosition,
                behavior: 'smooth'
            });
        }
    },
};
</script>

<style lang="less" scoped>
.el-header {
    background-color: #b3c0d1;
    color: #333;
    line-height: 40px;
}

//工具栏样式
.cust_seach {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    padding: auto 5px;

    .btnLeft {
        flex: 1;
        margin: 0;

        /deep/ .el-input__inner {
            height: 41px;
            border-radius: 0px;
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
        }
    }

    .btnTitle {
        flex: 2;
        margin: 0;

        /deep/ .el-input__inner {
            height: 41px;
            border-radius: 0px;
            border-top-left-radius: 0px;
            border-bottom-left-radius: 0px;
        }
    }

    .btnStatus {
        flex: 1;
        margin: 0;

        /deep/ .el-input__inner {
            height: 41px;
            border-radius: 0px;
            border-top-right-radius: 0px;
            border-bottom-right-radius: 0px;
        }
    }

    .el-button-group>.el-button:first-child:last-child {
        border-radius: 0px;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }
}

.el-select {
    float: left;
}

.cust_pagin {
    display: flex;
    position: sticky;
    bottom: 0;
    z-index: 999;
}

/deep/.el-breadcrumb__separator {
    color: rgb(87, 86, 86);
}

/deep/.el-input.is- .el-input__inner {
    color: #031944;
}

/deep/.el-textarea.is- .el-textarea__inner {
    color: #031944;
}

.headtool {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.miniTool {
    height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

//
.img-list {
    overflow: hidden;
    width: 100%;

    // 文件列表
    .img-li-box {
        float: left;
        text-align: left;
        position: relative;
        display: block; //Inline-block
        width: 200px;
        height: 270px;
        padding: 5px;
        margin: 5px 20px 20px 0;
        border: 1px solid #d1dbe5;
        border-radius: 4px;
        transition: all 0.3s;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);

        // 图片
        .img-li-b--url {
            display: block;
            width: 100%;
            height: 190px;
            margin: 0 auto;
            border-radius: 4px;
        }

        // 底部
        .img-li-b--bottom {
            margin-top: 10px;

            // 名称
            .img-li-b--name {
                width: 90%;
                text-overflow: ellipsis;
                overflow: hidden;
                height: 25px;
                line-height: 25px;
            }
        }

        // 删除按钮
        .img-li-b--delete {
            position: absolute;
            bottom: 10px;
            right: 10px;
            color: #8492a6;
            cursor: pointer;
            font-size: 1.1em;
        }

        // 放大遮罩层
        .img-li-b--layer {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            height: 200px;
            color: #fff;
            text-align: center;
            z-index: 5;
            background-color: rgba(0, 0, 0, 0.4);

            // 放大按钮
            i {
                font-size: 1.6em;
                margin-top: 80px;
            }
        }

        .img-li-b--delete,
        .img-li-b--layer {
            opacity: 0;
            transition: all 0.3s;
        }

        // 悬浮可见删除 or 放大按钮
        &:hover {

            .img-li-b--delete,
            .img-li-b--layer {
                opacity: 1;
            }
        }

        // 上传进度
        &.img-li-b--progress {
            // padding: 0;
            // text-align: center;
            // padding-top: 0px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    // 上传按钮
    .img-li-b--upload {
        float: left;
        width: 200px;
        height: 270px;
        display: table;
        text-align: center;

        .img-li-b--upl--field {
            width: 100%;
            display: table-cell;
            vertical-align: middle;
        }
    }
}

.el-dialog-div {
    margin: 0 auto;
    height: 500px;
    overflow: auto;
    display: flex;
    align-items: center;
}

/deep/ .el-drawer__body {
    overflow-y: none;
    padding: 5px 5px;
    margin-bottom: 50px;
}

.demo-drawer__footer {
    width: 100%;

    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: center;
    background-color: white;

    .el-button {
        flex: 1;
    }
}

//
.my-autocomplete {
    width: 500px;

    li {
        line-height: normal;
        padding: 7px;

        .name {
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .addr {
            font-size: 12px;
            color: #b4b4b4;
        }

        .highlighted .addr {
            color: #ddd;
        }
    }
}

.page-api {
    display: flex;
    width: 100%;
    height: calc(100vh - 400px);
    overflow-y: scroll;
    background-color: #fff;
    // margin: 10px;
    line-height: 200%;
}

.api-tree {
    position: fixed;
    right: 40px;
    top: 300px;
    width: 250px;
    height: 450px;
    margin-right: 10px;
    overflow-y: scroll;
    /* text-overflow: ellipsis; */
    z-index: 99;

    .el-tree {
        background: none;
        color: #686868;

        .el-tree-node:focus>.el-tree-node__content,
        .el-tree-node__content:hover {
            background: none;
            color: rgb(24, 144, 255);
        }
    }
}

.api-tree::-webkit-scrollbar {
    width: 8px;
}

.api-content {
    flex: 1;
    width: 80%;
    margin-left: 20px;
    margin-right: 250px;
    padding: 0 30px;

    h2 {
        margin-left: 20px;
        margin-bottom: 10px;
    }

    h3 {
        margin-left: 25px;
        margin-bottom: 8px;
    }

    h4 {
        margin-left: 30px;
        margin-bottom: 5px;
    }

    li {
        margin-left: 40px;
    }

    code {
        border-radius: 2px;
        color: #ffaa7f;
        margin: 0 2px;
        padding: 3px 5px;
        white-space: pre-wrap;
    }

    table {
        border-collapse: collapse;
        border-spacing: 0;

        th,
        td {
            border: 1px solid #ddd;
            padding: 6px 13px;
            margin: 0;
        }
    }

    pre {
        background: rgba(0, 0, 0, 0.7);
        padding: 20px 30px;
    }
}

.page-api::-webkit-scrollbar {
    width: 8px;
}

/* 滚动条滑块样式 */
.page-api::-webkit-scrollbar-thumb {
    background-color: #888;
    /* 设置滑块背景颜色 */
    border-radius: 4px;
    /* 设置滑块圆角 */
}
</style>
